import useSwr from "swr";
import api from "./api";

export function useFetchBuilding<Data = any, Error = any>() {
  const url = `/building`;

  const { data, error } = useSwr<Data, Error>(url, async (url) => {
    const response = await api.get(url);
    return response.data;
  });

  return { data, error };
}
